import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


export default ()=>{
  let map = document.querySelector('.info-block-map');
  if (!map) {return};

  let wrapper  = document.querySelector('.info-block-wrapper .left-block');

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function() {
      ScrollTrigger.create({
        trigger: wrapper,
        start: 'top 135px',
        end: 'bottom 100%',
        pin: map,
        scrub: true,
      });
    }
  });
}